type FileWithRelativePath = File & { relativePath?: string | null; path?: string | null }

/**
 * Browsers attach a non-standard relative-path property to files dropped as part of a folder:
 * `.relativePath` (via @uppy/utils' getDroppedFiles or react-dropzone's file-selector) or
 * `.path` (via file-selector). A standalone file may have "/file.pdf" or "./file.pdf";
 * the leading dot in the latter is a path marker, not a containing folder.
 *
 * A `webkitdirectory` input (the Folder-upload picker) sets neither, and instead populates the
 * standard `webkitRelativePath` — same shape but with no leading slash, which the split+filter
 * below already tolerates.
 */
export function getDroppedFilePathSegments(file: File): string[] {
  const { relativePath, path } = file as FileWithRelativePath
  const rawPath = relativePath || path || file.webkitRelativePath
  if (!rawPath) return []

  const segments = rawPath.split('/').filter(Boolean)
  // Drop the filename itself; only a containing folder means more than one segment.
  segments.pop()
  return segments[0] === '.' ? segments.slice(1) : segments
}
